import { render, staticRenderFns } from "./MedicationForm.vue?vue&type=template&id=d604160c&scoped=true"
import script from "./MedicationForm.vue?vue&type=script&lang=js"
export * from "./MedicationForm.vue?vue&type=script&lang=js"
import style0 from "./MedicationForm.vue?vue&type=style&index=0&id=d604160c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d604160c",
  null
  
)

export default component.exports